import {ContentBlock, VisibilityOption} from './types';
import {getVisibleContentBlocks} from '../../checklist-availability';

export const isBlockCompatibleWithVisibility = (
  block: ContentBlock,
  visibility: VisibilityOption,
) =>
  visibility !== 'anonymous' ||
  (block.type !== 'checklist' && block.type !== 'goals');

export const hasIncompatibleContent = (
  blocks: ContentBlock[],
  visibility: VisibilityOption,
) =>
  getVisibleContentBlocks(blocks).some(
    (block) => !isBlockCompatibleWithVisibility(block, visibility),
  );

export const isContentBlockValid = (block: ContentBlock) => {
  if (block.type === 'question') {
    return Boolean(block.questionData?.text?.trim());
  }

  if (block.type === 'checklist') {
    return Boolean(block.checklistData?.title?.trim());
  }

  return true;
};

export const isContentValid = (
  blocks: ContentBlock[],
  visibility: VisibilityOption,
) => {
  const visibleBlocks = getVisibleContentBlocks(blocks);

  return (
    visibleBlocks.length > 0 &&
    !hasIncompatibleContent(visibleBlocks, visibility) &&
    visibleBlocks.every(isContentBlockValid)
  );
};

export const getScrollIndicators = ({
  scrollTop,
  scrollHeight,
  clientHeight,
}: {
  scrollTop: number;
  scrollHeight: number;
  clientHeight: number;
}) => ({
  canScrollUp: scrollTop > 1,
  canScrollDown: scrollTop + clientHeight < scrollHeight - 1,
});
